module.exports = __webpack_public_path__ + "img/chaBing5.697db803.png";